import { z } from 'zod';
/** 채팅 composer 가 마이크 버튼 노출 여부를 결정하기 위해 호출하는 capability probe. */
export const SttCapabilitiesSchema = z.object({
    /** audio default endpoint 가 등록되어 있고 활용 가능하면 true. 실제 동작 여부는 시도해봐야 안다. */
    serverStt: z.boolean(),
});
/** /api/stt/transcribe 응답 — 추출된 텍스트만. */
export const SttTranscribeResponseSchema = z.object({
    text: z.string(),
});
//# sourceMappingURL=stt.js.map